module.exports = __webpack_public_path__ + "img/browse.c3e19269.svg";